import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-175" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-176" data-mp="j76soinpvto8">
        <SectionHeading id="summary-title" data-id="element-177" data-mp="j8880zbrn2br">Everything <span className="text-amber-400" data-id="element-178" data-mp="j5c7d38j9zjm">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-slate-800 bg-slate-900 shadow-sm sm:grid-cols-2" data-id="element-179" data-mp="1gu5tn5lfznrx">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-800 p-4 sm:odd:border-r" data-id="element-180" data-mp="16w83udnxpix7">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-400" data-id="element-181" data-mp="12u4gaqnzqnvk">
                <CheckIcon className="h-3.5 w-3.5 text-slate-950" aria-hidden="true" data-id="element-182" data-mp="3rnrwzm5elyl0" />
              </span>
              <b className="text-sm font-medium text-white" data-id="element-183" data-mp="3njtwb70fkfpu">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}